import {Level} from "types/Level";
import {dateTime} from "services/date";

/**
 * Transform the given level by deserializing object properties
 *
 * @internal
 * @param level
 */
export default function deserializeLevel(level: any): Level {
    level.created_at = dateTime(level.created_at)
    level.updated_at = dateTime(level.updated_at)

    return level;
}